import React from "react";
import Admin from "../../Dashboard";

const ApplicationServices = () => {
  return <Admin></Admin>;
};

export default ApplicationServices;
